export default function createShortName(fullName) {
  const list = fullName.split(" ");
  const first = list[0];
  if (!first) return "";
  if (list.length < 2) return first;
  var second = list[1];
  if (second.length > 2) return first + second.substring(0, 2);
  return first + second;
}
